import _ from "lodash";
import api from "CommonCore/api";
import apifetch from "CommonCore/apifetch";
import {
  inline,
} from "CommonState/action-helpers";
import {
  ENDPOINT_SETTINGS,
} from "App/constants";
import TR from "Common/translate";

const schema = { displayName: TR("Nutzer"),
                 formatWithDefinitiveArticle: p => (`das Profil ${ p.p_vorname } ${ p.p_name }`),
                 toUserString: n => (`${ TR("Nutzer") } ${ n.n_vorname }  ${ n.n_name }`),
                 defaultSort: [{ field: "n_name" }, { field: "n_vorname" }],
                 table: [
                   {
                     field: "n_vorname",
                     display: "Vorname",
                     maxlength: 100,
                     sortable: true,
                   },
                   {
                     field: "n_name",
                     display: "Name",
                     maxlength: 100,
                     sortable: true,
                   },
                   {
                     field: "n_email",
                     display: "E-Mail",
                     sortable: true,
                   },
                   {
                     field: "n_raum",
                     display: "Raum",
                     hideFromList: true,
                   },
                   {
                     field: "n_durchwahl",
                     display: "Durchwahl",
                     hideFromList: true,
                   },
                   {
                     field: "n_zustwiss",
                     display: "Zuständig Wissenschaft",
                     type: "checkbox",
                     hideFromList: true,
                   },
                   {
                     field: "n_zusttuv",
                     display: "Zuständig Technik/Verwaltung",
                     type: "checkbox",
                     hideFromList: true,
                   },
                   {
                     field: "n_svakuerzel",
                     display: "SVA-Kürzel",
                     maxlength: 20,
                     hideFromList: true,
                   },
                   {
                     field: "l_login",
                     display: "Login",
                     readonly: true,
                     sortable: true,
                   },
                   {
                     field: "l_letzte_login",
                     display: "Letztes Login",
                     type: "date",
                     readonly: true,
                     sortable: true,
                   },
                   {
                     field: "l_aktiv",
                     display: "Status",
                     readonly: true,
                     sortable: true,
                   },
                   {
                     field: "l_gesperrt",
                     display: "Gesperrt",
                     readonly: true,
                     sortable: true,
                   },

                 ] };

const desc = {
  id: "n_id",
  name: "nutzer",
  endpoint: "/api/shknutzer/admin",
  schema,
  nestedChildren: true,
  breadcrumbs: {
    list: "Nutzer",
    detail: n => schema.toUserString(n),
  },
};

const nutzerApi = api(desc);
export default nutzerApi;

const Placeholder = Object.freeze({});
export async function loadSetting(name) {
  const confName = `conf.${ name }`;
  inline({ [confName]: "shallow" }, state => _.set(state, confName, Placeholder));
  const result = await apifetch(`${ ENDPOINT_SETTINGS }/${ confName }`);
  inline({ [confName]: "shallow" }, state => {
    let data = _.get(state.conf, confName);
    if (data === Placeholder) {
      data = result || {};
    }
  });
  return result;
}

export async function saveSetting(name, value) {
  const confName = `conf.${ name }`;
  const keys = {
    [confName]: "deep+check",
  };

  await apifetch(`${ ENDPOINT_SETTINGS }/${ confName }`, {
    method: "PUT",
    body: JSON.stringify(value),
  });

  return inline(keys, state => {
    _.set(state.conf, confName, value);
  });
}
